import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UsersApi } from '../../clients';

export const useExportFacilityUsers = () => {
  const { t } = useTranslation();
  const [isExporting, setIsExporting] = useState(false);

  const exportUsers = useCallback(
    async (filters = {}) => {
      setIsExporting(true);
      try {
        const response = await UsersApi.exportFacilityUsers(filters);

        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `facility-users-${
          new Date().toISOString().split('T')[0]
        }.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        toast.success(t('facilityUserManagement.exportSuccess'));
      } catch (error) {
        console.error('Export failed:', error);
        toast.error(t('facilityUserManagement.exportError'));
        throw error;
      } finally {
        setIsExporting(false);
      }
    },
    [t],
  );

  return { exportUsers, isExporting };
};
